import { faCartShopping } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export default function Cartheading() {
  return (
<div className=" container mx-auto place-content-center p-4 flex items-center">
          <div className="text-5xl text-amber-500">
            <FontAwesomeIcon icon={faCartShopping} />
          </div>
          <div className="text-5xl font-navname text-amber-500">
            <p>My cart</p>
          </div>
        </div>
        
        )
}
